import React from 'react';
import MiscPaymentMasterDataConfig, { serviceTypeApi } from '../shared/MiscPaymentMasterDataConfig';

const ManageMiscPaymentServiceTypes = () => (
  <MiscPaymentMasterDataConfig title="Service Types" api={serviceTypeApi} />
);

export default ManageMiscPaymentServiceTypes;
